import Vue from 'vue';
import SkeletonComponent from '@/components/core/skeleton/skeleton.vue';
import { mapState } from 'vuex';

export default Vue.extend({
  components: {
    skeleton: SkeletonComponent
  },
  computed: {
    ...mapState('product', {
      selectedProductCountry: 'selected'
    })
  },
  methods: {
    startLocalization(neededInfos: {
      slides: any[];
      structure: any | null;
      type?: 'flow' | 'slides' | 'chapter';
    }): void {
      this.setState({
        name: 'setTargetCountry',
        component: () =>
          import(
            /* webpackChunkName: "dialogs" */ '@/components/localization/forms/select-target-country.vue'
          ),
        nextState:
          neededInfos.type && neededInfos.type !== 'slides'
            ? {
                name: 'changeStructureName',
                component: 'change-name',
                nextState: {
                  name: 'copySlides',
                  component: 'copy-slides',
                  nextState: {
                    name: 'finishLocalization',
                    component: 'finish-localization'
                  }
                }
              }
            : {
                name: 'copySlides',
                component: 'copy-slides',
                nextState: {
                  name: 'finishLocalization',
                  component: 'finish-localization'
                }
              }
      });
      this.$store.commit('localization/startLocalization', {
        slides: neededInfos.slides,
        type: neededInfos.type || 'slides',
        structure: neededInfos.structure
      });
    },
    async copy(slide: any, finish: boolean = false) {
      this.$store.commit('localization/addSlideToFinal', { slide });
      if (!finish) {
        this.nextStep();
      } else {
        await this.finish();
      }
    },
    async finish() {
      return await this.$store.dispatch('localization/finishLocalization').then(() => {
        this.$router.push({
          name: 'home',
          params: {
            product: this.selectedProductCountry.product._id,
            country: this.targetCountry
          }
        });
      });
    },
    async noCopy(finish: boolean = false) {
      this.$store.commit('localization/addSlideToFinal');
      if (!finish) {
        this.nextStep();
      } else {
        await this.finish();
        this.setState();
      }
    },
    previousStep() {
      this.$store.commit('localization/previous');
    },
    nextStep() {
      this.$store.commit('localization/next');
    },
    setState(state?: { name: string; component?: () => any; nextState: any }) {
      this.$store.commit('localization/setNextState', state);
    },
    copySlide(slide: any, index: number) {
      this.$store.commit('addSlideToFinal', { slide, index });
    },
    async duplicate() {
      return await this.$store.dispatch('localization/duplicate');
    },
    async setTargetCountry(country: string) {
      // eslint-disable-next-line no-console
      try {
        await this.$store.dispatch('localization/setTargetCountry', country);
      } catch (e) {
        // eslint-disable-next-line no-console
      }
    },
    setNewName(name: string | null) {
      this.$store.commit('localization/setNewName', name);
      this.setState();
    },
    endLocalization(withSaving: boolean = false) {
      if (withSaving) {
        this.$store.commit('localization/saveCurrentState');
      }
      this.$store.commit('localization/endLocalization');
    }
  }
});
